//Images
import React, {useRef} from "react";
import Lottie from "lottie-react";
import './Loader.css'
import animationData from '../../assets/animations/loader.json'
 
export default function Loader() {

        return (
        <div className="loader">
            <Lottie
                animationData={animationData} autoPlay={true} loop={true} height={150}  id="loader_animation"
            />
        </div>
        );
    
}